import { useState, useEffect } from "react";
import axios from "axios";
import useAuth from "../../auth/hooks/useAuth";

const useServices = params => {
  const [services, setServices] = useState();
  const [status, setStatus] = useState();
  const { state: authState } = useAuth();

  useEffect(() => {
    try {
      (async () => {
        setStatus("LOADING");
        console.log(process.env.REACT_APP_API);
        const response = await axios({
          method: "get",
          url: `${process.env.REACT_APP_API}/services`,
          params,
          headers: {
            Authorization: `Bearer ${authState.access_token}`
          }
        });
        console.log(response.data)
        setServices(response.data);
        if(services !== undefined)
        {
        console.log(services);
        }
        setStatus("OK");
      })();
    } catch (e) {
      setStatus("ERROR");
      console.log("error")
    }
  }, []);
  console.log(services);
    return {
      services,
      status
    };
};

export default useServices;
